export default __webpack_public_path__ + "static/media/publicacion3.83224091.jpg";